const getChatOrigin = (url) => {
  if (!url) return null;

  try {
    return new URL(url, window.location.href).origin;
  } catch (e) {
    return null;
  }
};

export default getChatOrigin;
